import { render } from "./DynamicLoading.vue?vue&type=template&id=0bd6b767"
import script from "./DynamicLoading.vue?vue&type=script&lang=ts"
export * from "./DynamicLoading.vue?vue&type=script&lang=ts"
script.render = render

export default script